import React from "react";
import { Modal, Button } from "rsuite";

const ConfirmActionModal = ({
  isOpen,
  actionType = "approve", // "approve" or "reject"
  title,
  message,
  onCancel,
  onConfirm,
  confirming = false,
}) => {
  const isApprove = actionType === "approve";

  return (
    <Modal open={isOpen} onClose={onCancel} backdrop={confirming ? "static" : true}>
      <Modal.Header>
        <Modal.Title>
          {title || (isApprove ? "Approve Request" : "Reject Request")}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p style={{ margin: 0, fontSize: "0.95rem", color: "#4b5563", lineHeight: 1.5 }}>
          {message}
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onCancel} appearance="subtle" disabled={confirming}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          appearance="primary"
          style={
            isApprove
              ? { backgroundColor: "#198754", color: "white" }
              : { backgroundColor: "#dc2626", color: "white" }
          }
          disabled={confirming}
        >
          {confirming
            ? isApprove
              ? "Approving…"
              : "Rejecting…"
            : isApprove
            ? "Approve"
            : "Reject"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmActionModal;

